import { useContext } from 'react';
import { VdpCardType } from '~/constants/home/VdpCardType';
import GlobalContext from '~/context/home/GlobalContext';
import RecentlyViewed from './RecentlyViewed';
import SuggestedForYou from './SuggestedForYou';

export default function TopCarousels() {
  const { vdpCardTypeShown } = useContext(GlobalContext);
  const isRecentlyViewedInVdpLinks = vdpCardTypeShown === VdpCardType.Recent;

  return (
    <>
      {isRecentlyViewedInVdpLinks ? (
        <>
          <SuggestedForYou />
          <RecentlyViewed />
        </>
      ) : (
        <>
          <RecentlyViewed />
          <SuggestedForYou />
        </>
      )}
    </>
  );
}
